import styled from 'styled-components';

import { theme } from '~/styles/theme';

export const Container = styled.form`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${theme.spacing.sm};
  align-items: center;
  background-color: rgb(100, 100, 100);

  h1 {
    color: #ffffff;
    font-weight: bold;
    font-size: 24px;
  }

  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: ${theme.spacing.sm};

    > svg {
      color: #ffffff;
    }
  }

  > div:last-of-type {
    > input {
      width: 300px;
      height: 30px;
      font-size: 18px;
      padding: ${theme.spacing.xs};
    }

    #spinner-container {
      width: 100px;
      height: 30px;
      display: flex;
      justify-content: center;
      align-items: center;
      > div {
        width: 30px;
        height: 30px;
      }
    }

    > button {
      width: 100px;
      height: 30px;
      background: #ffffff;
      border-radius: ${theme.borderRadius.sm};
      font-weight: bold;
    }
  }
`;
